import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Hue, Saturation } from 'react-color/lib/components/common';
import ColorInput from './ColorInput';
import Swatches from './Swatches';
import classnames from 'classnames';

class ColorPicker extends Component {
  onSwatchClick(hex) {
    this.props.onChange(hex);
  }

  render() {
    const {
      children,
      className,
      getRef,
      onChange,
      onKeyDown,
      showInput,
      style,
      swatches,
      width,
      ...color
    } = this.props;
    return (
      // The picker dialog captures Escape while its child controls have focus.
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <div
        className={classnames('bc-white rounded o-h', className)}
        style={{ width, ...style }}
        ref={getRef}
        onKeyDown={onKeyDown}
        role="dialog"
        tabIndex="-1"
      >
        <div className="pos-r" style={{ height: '10rem', width }}>
          <Saturation onChange={onChange} {...color} />
        </div>
        <div className="p3">
          <div className="pos-r rounded o-h" style={{ height: '10px' }}>
            <Hue onChange={onChange} {...color} />
          </div>
          {showInput || (swatches && swatches.length) ? (
            <div className="d-flex mt-16">
              {showInput && (
                <ColorInput
                  onChange={onChange}
                  value={color.hex}
                />
              )}
              <Swatches
                padLeft={showInput}
                swatches={swatches}
                onClick={this.onSwatchClick.bind(this)}
                color={color.hex}
              />
            </div>
          ) : null}
          {children && children(color)}
        </div>
      </div>
    );
  }
}

ColorPicker.defaultProps = {
  showInput: true,
  width: '20rem',
};

ColorPicker.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  getRef: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  showInput: PropTypes.bool,
  style: PropTypes.object,
  swatches: PropTypes.array,
  width: PropTypes.string,
};

export default ColorPicker;
